/**
 * Author: Tizian Schmidlin <st@cabag.ch>
 * License: MIT
 * 2017-08-08
 *
 * This script is part of the cabag_googlesearch distribution and handles the
 * queries against the cached and protected ajax backend in order to handle
 * google custom search queries.
 *
 * Special Thanks to:
 *  https://stackoverflow.com/questions/18673860/defining-a-html-template-to-append-using-jquery
 */

// ToDo: fix jQuery inclusion, #63850
var $ = require('../../node_modules/jquery');

if (!jQuery) {
    document.write('<span style="color:red;font-weight:bold;">jQuery is not loaded!</span>');
} else {
	(function ($) {
		// see https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript/901144#901144
		function getParameterByName(name, url) {
			if (!url)
				url = window.location.href;
			name = name.replace(/[\[\]]/g, "\\$&");
			var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
					results = regex.exec(url);
			if (!results)
				return '';
			if (!results[2])
				return '';
			return decodeURIComponent(results[2].replace(/\+/g, " "));
		}
		// see https://stackoverflow.com/questions/18673860/defining-a-html-template-to-append-using-jquery for explanation
		function render(props) {
			return function (tok, i) {
				return (i % 2) ? props[tok] : tok;
			};
		}

		// hide the facettes if there is only one
		if ($('.tx-cabaggooglesearch-engine').length <= 1) {
			$('.tx-cabaggooglesearch-engine').hide();
		}
    
        var currentPage = 1, lastSearch = '', currentContext = null;
        var resultsPerPage = 10, maxPages = 5, resultContainer = '#tx-cabaggooglesearch-result', facettesContainer = '#tx-cabaggooglesearch-facettes';

        if ($('.tx-cabaggooglesearch-engine').length > 0) {
            currentContext = $('.tx-cabaggooglesearch-engine').data('search-engine-id');
        }

        /**
         *
         * @param {String} the search term
         * @param {Object} a json object containing additional params
         */
        const search = function (q, additionalParams) {
            lastSearch = q;
            if (!additionalParams) {
                additionalParams = {};
            }
            additionalParams.cx = currentContext;
            additionalParams.pid = $('#tx-cabaggooglesearch-pid').val();
            additionalParams.sys_language_uid = $('#tx-cabaggooglesearch-sys_language_uid').val();

            additionalParams = '&' + $.param(additionalParams);

            var qs = encodeURIComponent(q);
            
            // get the value of tx-cabaggooglesearch-language or html-lang tag if it's set
            var searchLang = 'en';

            $.getJSON('/?eID=search&q=' + qs + additionalParams, function (data) {
                drawResults(data);
                
                if (typeof searchTracking === 'function'){
                    searchTracking(data, q);
                }
            });
        };


        /**
         * Get the template
         *
         * @param {String} template
         */
        const getTemplate = function (template) {
            return $('script[data-template="' + template + '"]').text().split(/\$\{(.+?)\}/g);
        }

        /**
         * Draw results
         *
         * @param {Object} data
         */
        const drawResults = function (data) {
            $(resultContainer).empty();
            
            if (data.searchInformation.totalResults == 0) {
                var noResults = $(getTemplate('list-no-results').join(''));
                $(resultContainer).append(noResults);
                return;
            }
            // Get facets from JSON
            $(facettesContainer).empty();
            if ('facets' in (data.context)) {
                if($('#tx-cabaggooglesearch-q').data('clickedfacetnr')==-1){
                    $(facettesContainer).html($(facettesContainer).html() + '<a href="#" class="facet tx-cabaggooglesearch-active" data-facetnr="-1" data-facet="">'+$("#tx-cabaggooglesearch-facettes").data('facet-all')+'</a>');
                }
                else{
                    $(facettesContainer).html($(facettesContainer).html() + '<a href="#" class="facet" data-facetnr="-1" data-facet="">'+$("#tx-cabaggooglesearch-facettes").data('facet-all')+'</a>');
                }
                
                for (var i = 0; i < data.context.facets.length; i++) {
                    var facet = data.context.facets[i]
                    var label = facet[0].label;
                    var anchor = facet[0].anchor;
                    var label_with_op = facet[0].label_with_op;

                    // Display facets in HTML
                    if($('#tx-cabaggooglesearch-q').data('clickedfacetnr')==i){
                        $(facettesContainer).html($(facettesContainer).html() + '<a href="#" data-facetnr="' + i + '" class="facet tx-cabaggooglesearch-active" data-facet="' + label_with_op + '">' + anchor + '</a>');
                    }
                    else{
                        $(facettesContainer).html($(facettesContainer).html() + '<a href="#" data-facetnr="' + i + '" class="facet" data-facet="' + label_with_op + '">' + anchor + '</a>');
                    }
                }
            }
            $('.facet').on('click', function (e) {
                e.preventDefault();
                $('#tx-cabaggooglesearch-q').data('clickedfacetnr',$(this).data('facetnr'));
                $('#tx-cabaggooglesearch-query').val($('#tx-cabaggooglesearch-q').val() + ' ' + $(this).attr('data-facet'));
                //$(this).addClass('active');
                $('#tx-cabaggooglesearch-form').submit();
            });

            var itemTmpl = getTemplate('listitem');

            for (var i in data.items) {
                //console.log(data.items[i].pagemap);
                if(data.items[i].hasOwnProperty('pagemap')){
                    if(data.items[i].pagemap.hasOwnProperty('cse_thumbnail')) {
                        data.items[i].thumbnail = data.items[i].pagemap.cse_thumbnail[0].src;
                    }
                }
                else{
                    data.items[i].thumbnail='';
                }
            }
			
            $(resultContainer).append(data.items.map(function (item) {
                return itemTmpl.map(render(item)).join('');
            }).join(''));

            if (data.searchInformation.totalResults > resultsPerPage) {
                drawPrevAndNext( data.searchInformation.totalResults, data.queries.request[0].startIndex);
            }


        }


        /**
         * draw prev and next arrows
         *
         * @param {Integer} totalResults the total amount of results
         */
        const drawPrevAndNext = function (totalResults, startIndex) {
            // this is just a container
            var $pager = $(getTemplate('list-pager').join(''));
            if (currentPage > 1) { // draw prev
                var $prev = $(getTemplate('list-pager-prev').join(''));
                $($prev).children('a').on(
                        'click', function (e) {
                            e.preventDefault();
                            search(lastSearch, {start: startIndex - 10});
                            currentPage--;
                        }
                );
                $pager.append($prev);
            }

            currentPage = (startIndex + 9) / 10;

            // pagination
            var startPaginate = 1, $paginateTemplate = $(getTemplate('list-paginate').join(''));

            if (currentPage > maxPages - 2 && currentPage - maxPages - 2 > 1) {
                startPaginate = currentPage - maxPages - 2;
            }

            var numberOfPages = Math.ceil(totalResults / 10);

            if(numberOfPages > 10) {
                numberOfPages = 10;
            }

            for (var i = startPaginate; i < numberOfPages; i++) {

                var $pageLink = $('<a>', {href: '#'}).text(i).data({'page': i}).on('click', function (e) {
                    var localPage = $(this).data('page');
                    e.preventDefault();
                    currentPage = localPage;
                    localPage = localPage * 10 - 9;
                    search(lastSearch, {start: localPage , googlehost: 'google.ch', filter: 0});
                });
                if (i == currentPage) {
                    $pageLink.addClass('bold');
                }
                $paginateTemplate.first('.list-paginate').append($pageLink);
            }

            $pager.append($paginateTemplate);

            if (currentPage * resultsPerPage < totalResults) { // draw next

                var $next = $(getTemplate('list-pager-next').join(''));
                $($next).first('a').on(
                        'click', function (e) {
                            e.preventDefault();
                            search(lastSearch, {start: startIndex + 10});
                            currentPage++;
                        }
                );
                $pager.append($next);
            }
            $(resultContainer).append($pager);
        }

        $(document).ready(function () {

            if (getParameterByName('q').length > 0) {
                search(getParameterByName('q'));
            }

            $('#tx-cabaggooglesearch-submit').on('click', function (e) {
                e.preventDefault();
                if ($('#tx-cabaggooglesearch-q').val().length > 0) {
                    currentPage = 1;
                    search($('#tx-cabaggooglesearch-q').val(), {googlehost: 'google.ch', filter: 0});
                }
                return false;
            });

            $('#tx-cabaggooglesearch-form').on('submit', function (e) {
                e.preventDefault();

                if ($('#tx-cabaggooglesearch-query').val().length > 0) {
                    search($('#tx-cabaggooglesearch-query').val());
                    $('#tx-cabaggooglesearch-query').val("");
                    return false;
                }

                if ($('#tx-cabaggooglesearch-q').val().length > 0) {
                    search($('#tx-cabaggooglesearch-q').val());
                    return false;
                }
                return false;
            });

            $('.tx-cabaggooglesearch-engine').each(function () {
                var $that = $(this);
                $(this).on('click', function () {
                    currentContext = $that.data('search-engine-id');
                    $('#tx-cabaggooglesearch-submit').trigger('click');
                });
            });

        });

    })(jQuery);
}
